/*custom js */
jQuery(document).on('click','.myHomeSwiper .swiper-slide', function(){
  if(jQuery(this).attr('data-href')!=undefined){
    window.location.href = jQuery(this).attr('data-href');
  }

  
});
jQuery(document).ready(function () {
  // <!-- Initialize Swiper -->
    jQuery('.category-description-text header .rte').unwrap();
  jQuery('.category-description-text .rte').removeClass('rte');

jQuery('.toggle-bottom-content-read-more').click(function(e){
  e.preventDefault();
  jQuery(this).next().slideDown();
jQuery(this).slideUp();
})
  jQuery('.toggle-bottom-content-read-less').click(function(e){
  e.preventDefault();
  jQuery('.toggle-bottom-content-read-more').slideDown();
jQuery('.toggle-bottom-content-wrap').slideUp();
})
  if( $('.collection-carousel-new.swiper-container').length){
        $('.collection-carousel-new.swiper-container').each(function(){
if($('.swiper-slide', $(this)).length < 4)
{
  $(this).hide();
   $(this).prev('h4').hide();
}
});
   var swiper2 = new Swiper('.collection-carousel-new.swiper-container', {
        slidesPerView: 4,
        slidesPerGroup:4,
        spaceBetween: 5,
        breakpoints: {
          700: {
            slidesPerView: 2,
            slidesPerGroup: 2
          },
          1200: {
            slidesPerView: 3 ,
            slidesPerGroup: 3
          },
          1600: {
            slidesPerView: 4 ,
            slidesPerGroup: 4
          }
        },
        loop: true,
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: {
          enabled: true,
          loadOnTransitionStart:true
        },
        followFinger:false,

       /* pagination: {
          el: '.swiper-pagination'
        },*/
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    

}
  if (jQuery('.categories_mobile_swiper').length) {
  var swiper = new Swiper(".categories_mobile_swiper", {
    spaceBetween: 10,
    slidesPerView: 6,
    centeredSlides: true,
    loop: true,
    slideToClickedSlide: true,
    pagination: {
      el: ".categories_swiper_pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.categories_swiper_next',
      prevEl: '.categories_swiper_prev',
    },
    breakpoints: {
      575: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      767: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1199: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1599: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
  }
  if (jQuery('.collection-swiper').length) {
  // <!-- Initialize Swiper -->
  var swiper = new Swiper(".collection-swiper", {
    spaceBetween: 30,
    slidesPerView: 5,
    loop: true,
    pagination: {
      el: ".collection-swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.collection-swiper-next',
      prevEl: '.collection-swiper-prev',
    },
    breakpoints: {
      575: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      767: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1199: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1599: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
  }
  //12-04-2022
  //   	jQuery('.product_desc ul').each(function(){
  // 		var ulli = jQuery(this).clone();
  //     	jQuery('.measurements').append(ulli);
  //     	jQuery(this).remove()
  // 	})


    $(".desc-accordion-product").find(".extend").click(function(){
    $(this).toggleClass("pactive").next().slideToggle("fast");
    $(".desc-accordion-product .extend").not($(this)).removeClass("pactive");
    $(".extended-submenu-prod").not($(this).next()).slideUp("fast").removeClass("pactive");
  })
  
  if (jQuery('.myHomeSwiper').length) {
    var swiper = new Swiper(".myHomeSwiper", {
            autoplay: {
    delay: 5000,
  },     loop: true,

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
  jQuery('.open_search').click(function (e) {
    e.preventDefault();
    jQuery('#cart-upper').addClass('displayblock');
    jQuery('#new-search').toggleClass('active');
  });
  jQuery('.close_search').click(function (e) {
    e.preventDefault();
    jQuery('#new-search').removeClass('active');
    jQuery('#cart-upper').removeClass('displayblock');

  });
  AOS.init({
    duration: 1200
  });
  jQuery('#shipLink').click(function (e) {
    e.preventDefault();
    jQuery('.ship_form').slideToggle();
  });
  // Scroll to anchor with scroll animation
  jQuery('[data-toggle="scroll"]').on('click', function (event) {
    var hash = jQuery(this).attr('href');
    var offset = jQuery(this).data('offset') ? jQuery(this).data('offset') : 0;
    // Animate scroll to the selected section
    jQuery('html, body').stop(true, true).animate({
      scrollTop: jQuery(hash).offset().top - offset
    }, 500);
    event.preventDefault();
  });
  jQuery('.zip-cal').submit(function () {
    var $this = jQuery(this).parent();
    var postcode = jQuery('[name="postcode"]', jQuery(this));
    var submitBtn = jQuery('button', jQuery(this));
    jQuery('.error', jQuery(this)).remove();
    if (postcode.val() != "") {
      submitBtn.prop('disabled', true);
      //       submitBtn.text("Calculating..");
      jQuery('.ship_loader').addClass('active');
      var priceText = jQuery('#product-price span').text();
      var price = parseFloat(priceText.substring(1));
      setTimeout(function () {
        if (postcode.val() != 4) {
          jQuery('.free', $this.next()).hide();
          jQuery('.standard', $this.next()).hide();
          jQuery('.express', $this.next()).hide();
          if ((postcode.val() >= 3000 && postcode.val() <= 3999) || (postcode.val() >= 8000 && postcode.val() <= 8999)) {
            if (price >= 60) {
              jQuery('.free', $this.next()).show();
            }
            else {
              jQuery('.standard', $this.next()).show();
              jQuery('.express', $this.next()).show();
            }
            jQuery($this.next()).show();
          }
          else if (isValidPostcode(postcode.val())) {
            if (price >= 60) {
              jQuery('.free', $this.next()).show();
            }
            else {
              jQuery('.standard', $this.next()).show();
            }
            jQuery($this.next()).show();
          }
          else {
            postcode.after("<p class='error'>Postcode is not valid.</p>");
          }
        }
        else {
          postcode.after("<p class='error'>Postcode is not valid.</p>");
        }
        submitBtn.prop('disabled', false);
        //       submitBtn.text("Calculate");
        jQuery('.ship_loader').removeClass('active');
      }, 500)
    }
    else {
      postcode.css("border-color", "red");
      postcode.after("<p class='error'>Field is required.</p>");
    }
    return false;
  })


jQuery(document).on("click", "#cart li:last-child", function(){
  alert("As we're undergoing changes, express shipping won't be available for order placed during 22nd to 28th of August");
})

  
});//ready end
function isValidPostcode(postcode) {
  if ((postcode >= 1000 && postcode <= 1999) || (postcode >= 2000 && postcode <= 2599) || (postcode >= 2619 && postcode <= 2899) || (postcode >= 2921 && postcode <= 2999)) {
    return true;
  }
  if ((postcode >= 0200 && postcode <= 0299 ) || (postcode >= 2600 && postcode <= 2618) || (postcode >= 2900 && postcode <= 2920))
  {
    return true;
  }
  if ((postcode >= 4000 && postcode <= 4999) || (postcode >= 9000 && postcode <= 9999)) {
    return true;
  }
  if ((postcode >= 5000 && postcode <= 5799) || (postcode >= 5800 && postcode <= 5999)) {
    return true;
  }
  if ((postcode >= 6000 && postcode <= 6797) || (postcode >= 6800 && postcode <= 6999)) {
    return true;
  }
  if ((postcode >= 7000 && postcode <= 7799) || (postcode >= 7800 && postcode <= 7999)) {
    return true;
  }
  if ((postcode >= 0800 && postcode <= 0899) || (postcode >= 0900 && postcode <= 0999)) {
    return true;
  }
  return false;
}